"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.config = {
    serviceUrls: {
        localization: 'services/x/localization/v1/',
        logging: 'services/x/logging/v1/',
        token: 'services/api/player/token'
    },
    paths: {
        mocks: 'mocks/'
    },
    const: {
        LOCALES: 'player.core'
    }
};



//////////////////
// WEBPACK FOOTER
// ./src/Config.ts
// module id = 22
// module chunks = 0